<script lang="ts">
	import type { Table } from "../types/Sanity";

	interface Props {
		portableText: { value: Table };
	}

	let { portableText }: Props = $props();
	const table: Table = $derived(portableText.value);
	const firstRow = $derived(table.rows[0]);
	const rows = $derived(table.rows.slice(1));
</script>

<table class="w-full border-spacing-x-8">
	<thead>
		<tr class="border-b-2">
			{#each firstRow.cells as cell, i (i)}
				<th>{cell}</th>
			{/each}
		</tr>
	</thead>
	<tbody>
		{#each rows as row, i (i)}
			<tr>
				{#each row.cells as cell, i (i)}
					<td>{cell}</td>
				{/each}
			</tr>
		{/each}
	</tbody>
</table>
